import { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  Text,
  Flex,
  Heading,
  HStack,
  Icon 
} from "@chakra-ui/react";
import {  FileUpload} from "@chakra-ui/react"

import { LuUpload } from "react-icons/lu"

const Profile = () => {
  const [phoneNumber, setPhoneNumber] = useState("07834968382");
  const [role, setRole] = useState("Store manager");
  const [language, setLanguage] = useState("English");
  const [image, setImage] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };

  return (
    <Box flex="1" pt="40px" px="8">
      {/* Header  */}
      <Flex justify="space-between" align="center" mb={8}>
        <Text fontSize="30px" color="#101828">
          Your profile
        </Text>
      </Flex>

      <VStack align="start" mb="62px" w="100%">
        <Heading color="#101828" fontSize="18px" fontWeight="normal">
          Personal info
        </Heading>
        <Box position="relative">
          <Heading color="#475467" fontSize="14px" fontWeight="normal">
            Update your photo and personal details here.
          </Heading>
        </Box>
      </VStack>

      {/* Main Form */}
      <VStack spacing={4} align="stretch">


    <FormControl  mb="44px">
      <HStack align="start" spacing="13px"> {/* Ensures a 13px gap */}
        <VStack align="start" spacing={0}  width="280px">
          <FormLabel fontSize="14px" color="#344054" mb={0}>
            Name
          </FormLabel>
          <Text fontSize="12px" color="#475467">
          Contact an admin to update these details
          </Text>
        </VStack>
        <Input
          value="Jerry"
          isReadOnly
          w="239px"
          h="35px"
          p="2px 12px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          bg="#f2f2f2"
          boxSizing="border-box"
          fontSize="14px"
          textColor="#667085"
        />
        <Input
          value="Hamilton"
          isReadOnly
          w="239px"
          h="35px"
          p="2px 12px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          bg="#f2f2f2"
          boxSizing="border-box"
           fontSize="14px"
          textColor="#667085"
        />
      </HStack>
    </FormControl>

    <FormControl mb="44px">
      <HStack align="start" spacing="13px"> {/* Ensures a 13px gap */}
        <VStack align="start" spacing={0}  width="280px">
          <FormLabel fontSize="14px" color="#344054" mb={0}>
          Email address
          </FormLabel>
          <Text fontSize="12px" color="#475467">
          Contact an admin to update these details
          </Text>
        </VStack>
        <Input
          value="jerry.hamilton@paragon-cc.co.uk"
          isReadOnly
          w="239px"
          h="35px"
          p="2px 12px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          bg="#f2f2f2"
          boxSizing="border-box"
          fontSize="14px"
          textColor="#667085"
        />
      </HStack>
    </FormControl>



    <FormControl mb="44px">
      <HStack align="start"> {/* Ensures a 13px gap */}
        <VStack align="start" spacing={0}  width="280px">
          <FormLabel fontSize="14px" color="#344054" mb={0}>
          Phone number
          </FormLabel>
        </VStack>
        <Input
          value="07834968382"
          isReadOnly
          w="239px"
          h="35px"
          p="2px 12px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          // bg="#f2f2f2"
          boxSizing="border-box"
          fontSize="14px"
          textColor="#667085"
        />
      </HStack>
    </FormControl>


    {/* <FileUpload.Root maxW="xl" alignItems="stretch" maxFiles={10}>
  <FileUpload.HiddenInput />
  <FileUpload.Dropzone>
    <Icon size="md" color="fg.muted">
      <LuUpload />
    </Icon>
    <FileUpload.DropzoneContent>
      <Box>Drag and drop files here</Box>
      <Box color="fg.muted">.png, .jpg up to 5MB</Box>
    </FileUpload.DropzoneContent>
  </FileUpload.Dropzone>
  <FileUpload.List />
</FileUpload.Root> */}

        

<FormControl mb="44px">
      <HStack align="start"> {/* Ensures a 13px gap */}
        <VStack align="start" spacing={0}  width="280px">
          <FormLabel fontSize="14px" color="#344054" mb={0}>
          Role
          </FormLabel>
        </VStack>
        <Input
          value="Store manager"
          w="239px"
          h="35px"
          p="2px 12px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          // bg="#f2f2f2"
          boxSizing="border-box"
          fontSize="14px"
          textColor="#667085"
        />
      </HStack>
    </FormControl>

    <FormControl mb="44px">
      <HStack align="start">
        <VStack align="start" spacing={0}  width="280px">
          <FormLabel fontSize="14px" color="#344054" mb={0}>
            Language
          </FormLabel>
        </VStack>
        <Select
          w="239px"
          h="35px"
          p="2px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          // bg="#f2f2f2"
          boxSizing="border-box"
          fontSize="14px"
          textColor="#667085"
          defaultValue="English"
        >
          <option value="English">English</option>
          <option value="Spanish">Spanish</option>
          <option value="French">French</option>
          <option value="German">German</option>
        </Select>
      </HStack>
    </FormControl>

    <Box w="100%" display="flex" justifyContent="flex-end" mt="24px">
      <Button
        background="#1e98d7"
        color="#ffffff"
        _hover="none"
        fontSize="14px"
        width=""
      >
        Update your profile
      </Button>
      
    </Box>
      </VStack>
      <div style={{width:"100%", height:"1px", backgroundColor:"#eaecf0", margin:"32px 0px"}}></div>
     

      <VStack align="start" mb="62px" w="100%">
        <Heading color="#101828" fontSize="18px" fontWeight="normal">
        Password
        </Heading>
        <Box position="relative">
          <Heading color="#475467" fontSize="14px" fontWeight="normal">
          Update your password here
          </Heading>
        </Box>
      </VStack>

      <FormControl mb="44px">
      <HStack align="start"> {/* Ensures a 13px gap */}
        <VStack align="start" spacing={0}  width="280px">
          <FormLabel fontSize="14px" color="#344054" mb={0}>
          Current password
          </FormLabel>
        </VStack>
        <Input
          value=""
          isReadOnly
          w="239px"
          h="35px"
          p="2px 12px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          // bg="#f2f2f2"
          boxSizing="border-box"
          fontSize="14px"
          textColor="#667085"
        />
      </HStack>
    </FormControl>

    <FormControl mb="44px">
      <HStack align="start"> {/* Ensures a 13px gap */}
        <VStack align="start" spacing={0}  width="280px">
          <FormLabel fontSize="14px" color="#344054" mb={0}>
          New password
          </FormLabel>
        </VStack>
        <Input
          value=""
          isReadOnly
          w="239px"
          h="35px"
          p="2px 12px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          // bg="#f2f2f2"
          boxSizing="border-box"
          fontSize="14px"
          textColor="#667085"
        />
      </HStack>
    </FormControl>


    <FormControl mb="44px">
      <HStack align="start"> {/* Ensures a 13px gap */}
        <VStack align="start" spacing={0}  width="280px">
          <FormLabel fontSize="14px" color="#344054" mb={0}>
          Confirm new password
          </FormLabel>
        </VStack>
        <Input
          value=""
          isReadOnly
          w="239px"
          h="35px"
          p="2px 12px"
          borderRadius="8px"
          border="1px solid #d0d5dd"
          // bg="#f2f2f2"
          boxSizing="border-box"
          fontSize="14px"
          textColor="#667085"
        />
      </HStack>
    </FormControl>

    

    <Box w="100%" display="flex" justifyContent="flex-end" mt="24px">
      <Button
        background="#1e98d7"
        color="#ffffff"
        _hover="none"
        fontSize="14px"
        width=""
        mb={5}
      >
       Update your password
      </Button>
      
    </Box>



    </Box>
    
  );
};


export default Profile;
